import React from "react";

const FormCheck: React.FC = ({ children }) => {
  return <div className="form-check">{children}</div>;
};

export default FormCheck;
